// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root___oohy","header":"ClearentDisclaimer_header__2oOgG","inner":"ClearentDisclaimer_inner__2NxGR"};